var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sdr-box contact-box"},[_c('h4',{staticStyle:{"color":"#944579","font-weight":"700"},domProps:{"innerHTML":_vm._s(_vm.importantinfosheader[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.importantinfostext[_vm.getCurrentLocale])}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71e335f8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/sidebar/ImportantInfos3Box.vue
// module id = 430
// module chunks = 0